import * as Sentry from '@sentry/react';

const dsn = import.meta.env['VITE_SENTRY_DSN'] as string | undefined;

export function initSentry() {
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env['MODE'],
    release: `web-partner@${import.meta.env['VITE_APP_VERSION'] ?? '0.0.1'}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: import.meta.env['PROD'] ? 0.2 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: import.meta.env['PROD'] ? 1.0 : 0,
  });
}

export { Sentry };
